// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + "e25b8687" + "." + "9bd6ab81441a4861" + ".js";
};